import React, { useEffect } from "react";

import { SEARCH_KEY } from "fond/constants";
import SearchResults from "fond/projects/GlobalSearch/SearchResults";
import { Navigation } from "fond/projects/Navigation";
import { updateFilter } from "fond/projects/redux";
import StarredContent from "fond/projects/StarredContent";
import { useAppDispatch, useQueryParams } from "fond/utils/hooks";
import { PageContent } from "fond/widgets";

/**
 * A top level component used for displaying starred projects.
 */
const Starred: React.FC = () => {
  const dispatch = useAppDispatch();

  // Clear filter
  useEffect(() => {
    dispatch(updateFilter(null));
  }, [dispatch]);

  // Global search results page
  const searchQuery = useQueryParams(SEARCH_KEY);
  if (searchQuery) {
    return <SearchResults />;
  }

  return <PageContent title="Starred" mainContent={<StarredContent />} navigation={<Navigation />} testId="filter-starred" />;
};

export default Starred;
